"use client"

import { useTheme } from "@/components/theme/theme-provider"
import type { ReactNode } from "react"

interface ThemeWrapperProps {
  children: ReactNode
  className?: string
}

export default function ThemeWrapper({ children, className = "body" }: ThemeWrapperProps) {
  const { theme } = useTheme()

  return <div className={`${className} ${theme === "dark" ? "black-mode" : ""}`}>{children}</div>
}
